// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-653d284e] .formulate-input-element {

    display: flex;

    align-items: center;

    border-radius: 12px;

    border-width: 1px;

    border-style: solid;

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
[data-v-653d284e] .formulate-input-element--group {

    display: flex;

    flex-direction: column;

    gap: 0.75rem
}
[data-is-showing-errors='true'][data-v-653d284e] .formulate-input-element {

    --tw-border-opacity: 1;

    border-color: rgb(216 0 3 / var(--tw-border-opacity))
}
[data-v-653d284e] .formulate-input-prefix,[data-v-653d284e] .formulate-input-suffix {

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
.formulate-input[data-v-653d284e] input {

    width: 100%;

    border-width: 0px;

    border-style: none;

    padding-left: 0.25rem;

    padding-right: 0.25rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
.formulate-input[data-v-653d284e] input:focus {

    outline: 2px solid transparent;

    outline-offset: 2px
}
.formulate-input[data-v-653d284e] input:disabled {

    --tw-bg-opacity: 1;

    background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/inputs/text/TextInput.vue"],"names":[],"mappings":";AAgCA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAGA;;IAAA,sBAAA;;IAAA;AAAA;AAKA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAKA;;IAAA,WAAA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,qBAAA;;IAAA,sBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAAA;;IAAA,8BAAA;;IAAA;AAAA;AAAA;;IAAA,kBAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <FormulateInput :type=\"type\" v-bind=\"$attrs\" :key=\"value\" :value=\"value\" @option:selecting=\"$emit('option:selecting', $event)\" @option:selected=\"$emit('option:selected', $event)\" @input=\"$emit('input', $event)\">\n    <template #prefix>\n      <div class=\"formulate-input-prefix\">\n        <slot name=\"prefix\"></slot>\n      </div>\n    </template>\n    <template #suffix>\n      <div class=\"formulate-input-suffix\">\n        <slot name=\"suffix\"></slot>\n      </div>\n    </template>\n  </FormulateInput>\n</template>\n\n<script>\nexport default {\n  props: {\n    type: {\n      type: String,\n      default: 'text',\n    },\n    value: {\n      type: String,\n    },\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n/deep/ .formulate-input {\n  &-element {\n    @apply flex items-center bg-neutral-white border-solid border-hairline border-neutral-semilight rounded-md;\n\n    &--group {\n      @apply flex flex-col gap-micro;\n    }\n    [data-is-showing-errors='true']& {\n      @apply border-feedback-error-medium;\n    }\n  }\n  &-prefix,\n  &-suffix {\n    @apply px-nano py-micro style-body-sm;\n  }\n}\n.formulate-input::v-deep {\n  input {\n    @apply w-full px-quark border-none text-neutral-ultradark py-micro disabled:bg-neutral-lightest style-body-sm focus:outline-none;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
